import React, { Component } from 'react';
import { Link } from "gatsby";
import theme from '../autocomplete.module.css'
import '../App.css';
import { Row, Col, Form, Button, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Autosuggest from 'react-autosuggest';

import { HotKeys } from "react-hotkeys";
import Layout from '../Frame/Layout';
import { Helmet } from "react-helmet";
import favicon from '../images/favicon.ico'
import $ from 'jquery';

import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

import Common from '../Common';
import AnalysisResult from '../Common/AnalysisResult';
import SLogin from '../Common/SLogin/SLogin';
import TitleAndMore from '../Common/TitleAndMore/TitleAndMore';
import PremiumIndicator from '../Common/PremiumIndicator';
import PlayBehaviorModal from '../components/PlayBehavior/PlayBehaviorModal';
import Auth from '../Common/Auth';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import { window, document } from 'browser-monads'

class AutoCompleteInput extends Component {
    constructor(props) {
        super(props);

        this.numberList = ["A", "K", "Q", "J", "T", "10", "9", "8", "7", "6", "5", "4", "3", "2"]
        this.suitList = ["s", "h", "c", "d"]
    }

    generateSuggestions = () => {
        let cardStr = this.props.value.toUpperCase()
        let suggestions = []
        let firstHand = this.props.parent.state.myFirstCard
        let secondHand = this.props.parent.state.mySecondCard
        let sharedCards = this.props.parent.state.communityCards

        if(!cardStr.includes("10")) {
            if(cardStr.length<=2) {
                if(this.numberList.includes(cardStr[0])) {
                    this.suitList.forEach(suit => {
                        let suggestedCard = cardStr[0] + suit

                        if(!Common.isCardPresent(firstHand, secondHand, sharedCards, suggestedCard)) {
                            suggestions.push(suggestedCard)
                        }

                        if(this.props.value === suggestedCard) {
                            suggestions.push(suggestedCard)
                        }
                    })
                }
            }
        } else {
            this.suitList.forEach(suit => {
                let suggestedCard = "10" + suit

                if(!Common.isCardPresent(firstHand, secondHand, sharedCards, suggestedCard)) {
                    suggestions.push(suggestedCard)
                }

                if(this.props.value === suggestedCard) {
                    suggestions.push(suggestedCard)
                }
            })
        }

        return suggestions
    }

    renderSuggestion = (suggestion) => {
        let textClass = ""

        if(suggestion.includes('h') || suggestion.includes('d')) {
            textClass = "red"
        }

        return (
            <span className={textClass}>{suggestion}</span>
        )
    }
    
    render() {
        let suggestions = this.generateSuggestions()
        let inputProps = {
            placeholder: this.props.placeholder,
            value: this.props.value,
            onChange: this.props.onChange
        }

        return (
        <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={() => {}}
            onSuggestionsClearRequested={() => {}}
            getSuggestionValue={e => e}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps}
            theme={theme}
        />
        )
    }
}

class AdvancedView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            numPlayer: "6",
            myFirstCard: "",
            mySecondCard: "",
            communityCards: ["", "", "", "", ""],
            myWinRate: "--",
            opponentsWinRate: "--",
            opponentsWinningHandStatus: "",
            top5OpponentHand: [], 
            action: "--",
            handPct: "--",
            minPaybackRatio: -1,
            optimalBet: {},
            analysisColorClass: "",
            isCalculating: false,
            emperorToken: null
        };

        this.keyMap = {
            CALCULATE: ["command+enter", "ctrl+enter", "ctrl+space"],
            CLEAR: ["ctrl+z", "command+z"]
        };

        this.keyHandlers = {
            CALCULATE: this.getAnalysisFromServer,
            CLEAR: this.clearCards
        }
    }

    handleNumPlayerChange = (e) => {
        this.setState({numPlayer: e.target.value.replace(/\s/g,'')})
    }

    handleMyFirstCardChange = (e, {newValue}) => {
        this.setState({myFirstCard: newValue.replace(/\s/g,'')})
    }

    handleMySecondCardChange = (e, {newValue}) => {
        this.setState({mySecondCard: newValue.replace(/\s/g,'')})
    }

    handleCommunityCardChange = (i, e, newValue) => {
        let communityCards = this.state.communityCards
        communityCards[i] = newValue.replace(/\s/g,'')
        this.setState({communityCards: communityCards})
    }

    clearCards = () => {
        this.setState({
            myFirstCard: "",
            mySecondCard: "",
            communityCards: ["", "", "", "", ""],
            myWinRate: "--",
            handPct: "--",
            opponentsWinRate: "--",
            opponentsWinningHandStatus: "",
            top5OpponentHand: [], 
            action: "--",
            minPaybackRatio: -1,
            optimalBet: {},
            analysisColorClass: "",
        })

        document.querySelector("#first-card div input").focus()
    }

    setToken = (token) => {
        this.setState({emperorToken: token})
    }

    generateQueryString = () => {
        return Common.generateQueryString(this.state)
    }

    getAnalysisFromServer = () => {
        Common.getAnalysisFromServer(this)
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log(this.state)
    }

    componentDidMount() {
        $("body").keydown(function(e){
            var zKey = 90;
            if ((e.ctrlKey || e.metaKey) && e.keyCode == zKey) {
                e.preventDefault();
                return false;
            }
        });
    }

    render() {
        let auth = new Auth(null);
        let token = auth.getLocalToken()

        return (
        <HotKeys keyMap={this.keyMap} handlers={this.keyHandlers}>
            <Layout>
                <Helmet>
                    <title>Advanced Poker Odds Calculator & Analyzer - Edge.Poker</title>
                    <meta name="description" content="Calculate your odds of winning and get coaching advice in Texas Hold'em poker quickly using Edge Poker advanced view." />
                    <meta name="keywords" content="advanced poker odds calculator, advanced poker calculator" />
                    <link rel="canonical" href="https://app.edge.poker/advanced" />
                    <link rel="icon" href={favicon} />
                    <meta http-equiv="content-language" content="en-us"></meta>
                    <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Roboto&display=swap" onload="this.onload=null;this.rel='stylesheet'"></link>  
                    <script src="/sl.js" type='text/javascript'/>
                </Helmet>
                <Loader fullPage loading={this.state.isCalculating}/>
                <SLogin setTokenHandler={this.setToken}/>
                <Row>
                    <Col xs="0" lg="2"> </Col>
                    <Col xs="12" lg="8">
                        <PremiumIndicator/>
                        <TitleAndMore/>
                        <Form>
                            <Form.Group as={Row} controlId="numPlayer">
                                <Form.Label column xs="12">
                                    <div># of Player</div>
                                    <div className="small-font mb-2">
                                        Total counts of all players including folded players.
                                    </div>
                                </Form.Label>
                                <Col xs="6" sm="4" md="3">
                                    <Form.Control value={this.state.numPlayer} 
                                    onChange={this.handleNumPlayerChange}/>
                                </Col>
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                <Form.Label>
                                    My Cards
                                </Form.Label>
                                <Row className="mb-2">
                                    <Col id="first-card">
                                        <AutoCompleteInput
                                        placeholder="1st card, e.g. 4s, Kd, ..." 
                                        parent={this}
                                        value={this.state.myFirstCard} 
                                        onChange={this.handleMyFirstCardChange}/>
                                    </Col>
                                    <Col>
                                        <AutoCompleteInput
                                        placeholder="2nd card, e.g. Tc, 7h, ..." 
                                        parent={this}
                                        value={this.state.mySecondCard} 
                                        onChange={this.handleMySecondCardChange}/>
                                    </Col>
                                </Row>
                                <Form.Label>
                                    <div className="small-font mb-2">
                                        For suits: use 'd' for Diamonds, 'c' for Clovers, 'h' for Hearts and 's' for Spades
                                    </div>
                                    <div className="small-font mb-2">
                                        For special numbers: use 'T' for 10, 'J' for Jack, 'Q' for Queen, 'K' for King and 'A' for Aces
                                    </div>
                                </Form.Label>
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                <Form.Label>
                                    <div>
                                        Shared/Community Cards
                                    </div>
                                    <div className="small-font">
                                        Leave empty when unknown
                                    </div>
                                </Form.Label>
                                <Row>
                                    <Col xs="4" sm="2" className="mb-3">
                                        <AutoCompleteInput
                                        placeholder="Flop" 
                                        parent={this}
                                        value={this.state.communityCards[0]} 
                                        onChange={(e, {newValue}) => this.handleCommunityCardChange(0, e, newValue)}/>
                                    </Col>
                                    <Col xs="4" sm="2" className="mb-3">
                                        <AutoCompleteInput
                                        placeholder="Flop" 
                                        parent={this} 
                                        value={this.state.communityCards[1]} 
                                        onChange={(e, {newValue}) => this.handleCommunityCardChange(1, e, newValue)}/>
                                    </Col>
                                    <Col xs="4" sm="2" className="mb-3">
                                        <AutoCompleteInput
                                        placeholder="Flop" 
                                        parent={this}
                                        value={this.state.communityCards[2]} 
                                        onChange={(e, {newValue}) => this.handleCommunityCardChange(2, e, newValue)}/>
                                    </Col>
                                    <Col xs="4" sm="2" className="mb-3">
                                        <AutoCompleteInput
                                        placeholder="Turn" 
                                        parent={this}
                                        value={this.state.communityCards[3]} 
                                        onChange={(e, {newValue}) => this.handleCommunityCardChange(3, e, newValue)}/>
                                    </Col>
                                    <Col xs="4" sm="2" className="mb-3">
                                        <AutoCompleteInput
                                        placeholder="River" 
                                        parent={this}
                                        value={this.state.communityCards[4]} 
                                        onChange={(e, {newValue}) => this.handleCommunityCardChange(4, e, newValue)}/>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Row>
                                <Col xs="12" className="text-center mt-3">
                                    <Button className="win-rate-button mr-3" onClick={this.getAnalysisFromServer}>Calculate Win Rate</Button>
                                    <Button className="clear-btn" onClick={this.clearCards}>
                                        <FontAwesomeIcon icon={faTimes} className="mr-2"/>
                                        Clear Cards
                                    </Button>
                                </Col>
                                <Col xs="12" className="text-center mt-4">
                                    <div className="small-font mb-2">
                                        <span className="mr-3">Shortcut Key to Calculate:</span>
                                        <span>Ctrl+Enter or Ctrl+Space</span>
                                    </div>
                                    <div className="small-font mb-2">
                                        <span className="mr-3">Shortcut Key to Clear:</span>
                                        <span>Ctrl+z</span>
                                    </div>
                                </Col>
                            </Row>

                        </Form>
                    
                        <hr/>
                        <div className="mt-4"></div>
                        <AnalysisResult state={this.state}/>

                        <hr/>
                        <div className="mt-5 mb-5 text-center">
                            <Link to="/" className="switch">Switch to Simple View</Link>
                        </div>

                        { token && (
                            <div>
                                <hr/>
                                <PlayBehaviorModal/>
                            </div>
                        )}
                    </Col>
                    <Col xs="0" lg="2"> </Col>
                </Row>
            </Layout>
        </HotKeys>
        );
    }
}

export default AdvancedView;